export enum InterestedPartiesFormLabelsEnum {
  TITLE = 'Watchers',
  TITLE_FOR_SELECT_EMPLOYEE_DIALOG = 'Add Watcher',
  ADD_PARTY = 'Add watcher',
  DESCRIPTION = 'Watchers (XPO internal employees) will be kept informed throughout the life-cycle of this dispute',
  INTERESTED_PARTIES_EMPTY = 'No XPO Employees added.',
}
